namespace AgerLMS {
    export enum DetailMetaTypes {
        UserEducation = 0,
        UserExperience = 1,
        CategoryTopic = 2,
        Requirement = 3,
        LearningMaterials = 4
    }
    Serenity.Decorators.registerEnumType(DetailMetaTypes, 'AgerLMS.DetailMetaTypes');
}
